/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { styled } from '@mui/material/styles';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  ListItemButton,
} from '@mui/material';
import LabelChip from '../shared/label-chip';
import { setActiveColor } from './sidenav-helpers';
import type { SystemAppIds } from './sidenav-helpers';

interface Props {
  title: string;
  links: Link[];
  systemAppIds: SystemAppIds
}

interface Link {
  name: string;
  url: string;
  chip?: {
    title: string;
    color?: string;
  };
}

const Section = styled(Box)({
  borderBottom: '1px solid #eee',
  paddingTop: 20,
  paddingBottom: 20,
  ':last-of-type': {
    borderBottom: 'none',
  },
});

const Title = styled(ListSubheader)({
  color: '#41403b',
  margin: 0,
  textTransform: 'uppercase',
  background: 'transparent',
  fontWeight: 900,
  lineHeight: 2,
  padding: '0 24px',
});

const SectionLinkContainer = styled(ListItem)({
  flexDirection: 'column',
  alignItems: 'flex-start',
  lineHeight: 1.4,
});

const SectionLink = styled(ListItemButton)({
  fontSize: 14,
  color: '#767676',
  display: 'block',
  padding: '0 24px',
  width: '100%',
  ':hover': {
    background: '#fff',
    color: '#000',
  },
});

export const SidenavSection: React.FC<Props> = ({ ...props }) => {
  const { links, title } = props;

  return (
    <Section>
      <List
        aria-label="nav-section"
        {...(title && {
          subheader: <Title sx={{ fontSize: '10px' }}>{title}</Title>,
        })}
      >
        <SectionLinkContainer disablePadding>
          {links.map((item, i) => (
            <SectionLink
              disableRipple
              // @ts-ignore
              component="a"
              // Link names must be present in ./sidenav-helpers route map.
              key={i}
              style={setActiveColor(item.name, props.systemAppIds)}
              href={item.url}
            >
              <ListItemText
                data-testing-id={`sidenav-links-${item.name}`}
                primary={(
                  <Box component="span" display="inline">
                    {item.name}
                    {item.chip && <LabelChip label={item.chip.title} color={item.chip.color} />}
                  </Box>
                )}
                primaryTypographyProps={{ fontSize: '13px' }}
              />
            </SectionLink>
          ))}
        </SectionLinkContainer>
      </List>
    </Section>
  );
};

export default SidenavSection;
